(function () {
  function applyMrArtzJudgeBadgeSize() {
    if (!document.getElementById('mrartz-judge-badge-size')) {
      var style = document.createElement('style');
      style.id = 'mrartz-judge-badge-size';
      style.textContent = 'html body .product__info-container .jdgm-prev-badge .jdgm-star{font-size:13.5px!important}.product__info-container .jdgm-prev-badge__text{font-size:13px!important}';
      document.head.appendChild(style);
    }

    function syncJudgeBadgeRating() {
      document.querySelectorAll('.product__info-container .jdgm-prev-badge__text').forEach(function (badgeText) {
        Array.prototype.slice.call(badgeText.childNodes).forEach(function (node) {
          if (node.nodeType === 3 && node.nodeValue.indexOf('4.9') !== -1) {
            node.nodeValue = node.nodeValue.replace(/4\.9/g, '4.8');
          }
        });
      });
    }

    syncJudgeBadgeRating();

    if (!document.documentElement.dataset.mrartzJudgeRatingObserver) {
      document.documentElement.dataset.mrartzJudgeRatingObserver = 'true';
      new MutationObserver(syncJudgeBadgeRating).observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true
      });
    }
  }

  function initMrArtzGalleryProgress() {
    applyMrArtzJudgeBadgeSize();
    if (window.innerWidth >= 750) return;

    document.querySelectorAll('media-gallery').forEach(function (gallery) {
      if (gallery.dataset.mrartzProgressReady === 'true') return;

      var progress = gallery.querySelector('.mrartz-mobile-gallery-progress');
      var counter = gallery.querySelector('.slider-counter--current');
      var mediaList = gallery.querySelector('.product__media-list');
      if (!progress || !counter || !mediaList) return;

      var bars = Array.prototype.slice.call(
        progress.querySelectorAll('.mrartz-mobile-gallery-progress__bar')
      );
      if (bars.length < 2) return;

      gallery.dataset.mrartzProgressReady = 'true';

      var indicator = bars[0];
      var currentIndex = 0;
      var scrollRaf = null;

      bars.forEach(function (bar, index) {
        bar.style.setProperty('width', 100 / bars.length + '%', 'important');
        if (index > 0) {
          bar.style.setProperty('display', 'none', 'important');
          bar.style.setProperty('opacity', '0', 'important');
          bar.style.setProperty('background', 'transparent', 'important');
          bar.style.setProperty('transform', 'none', 'important');
          bar.classList.remove('is-active');
        }
      });

      indicator.style.setProperty('display', 'block', 'important');
      indicator.style.setProperty('opacity', '1', 'important');
      indicator.style.setProperty('background', '#111', 'important');
      indicator.classList.add('is-active');

      function setIndex(index, animate) {
        index = Math.max(0, Math.min(index, bars.length - 1));
        currentIndex = index;
        indicator.style.setProperty('width', 100 / bars.length + '%', 'important');
        indicator.style.setProperty(
          'transition',
          animate ? 'transform .28s cubic-bezier(.22,.61,.36,1)' : 'none',
          'important'
        );
        indicator.style.setProperty(
          'transform',
          'translateX(' + index * 100 + '%)',
          'important'
        );
      }

      function indexFromCounter() {
        var index = parseInt(counter.textContent, 10) - 1;
        if (isNaN(index)) index = 0;
        return Math.max(0, Math.min(index, bars.length - 1));
      }

      function getRealSlides() {
        return Array.prototype.slice.call(
          mediaList.querySelectorAll('.product__media-item')
        ).filter(function (slide) {
          return !slide.classList.contains('mrartz-mobile-loop-clone') &&
            !slide.classList.contains('mrartz-loop-clone');
        });
      }

      function forceFirstState() {
        setIndex(0, false);
        if (counter.textContent.trim() !== '1') {
          counter.textContent = '1';
        }
      }

      function syncFromScroll() {
        scrollRaf = null;

        var realSlides = getRealSlides();
        if (!realSlides.length) return;

        var visualSlides = Array.prototype.slice.call(
          mediaList.querySelectorAll('.product__media-item')
        ).filter(function (slide) {
          return !slide.classList.contains('mrartz-loop-clone');
        });

        if (!visualSlides.length) return;

        var listRect = mediaList.getBoundingClientRect();
        var viewportCenter = listRect.left + listRect.width / 2;
        var closestSlide = visualSlides[0];
        var closestDistance = Infinity;

        visualSlides.forEach(function (slide) {
          var rect = slide.getBoundingClientRect();
          var slideCenter = rect.left + rect.width / 2;
          var distance = Math.abs(slideCenter - viewportCenter);

          if (distance < closestDistance) {
            closestDistance = distance;
            closestSlide = slide;
          }
        });

        if (closestSlide.classList.contains('mrartz-mobile-loop-clone')) {
          forceFirstState();
          return;
        }

        var closestIndex = realSlides.indexOf(closestSlide);
        if (closestIndex < 0) closestIndex = 0;

        if (closestIndex !== currentIndex) {
          setIndex(closestIndex, true);
        }

        var shownNumber = closestIndex + 1;
        if (counter.textContent.trim() !== String(shownNumber)) {
          counter.textContent = String(shownNumber);
        }
      }

      function requestScrollSync() {
        if (scrollRaf !== null) return;
        scrollRaf = requestAnimationFrame(syncFromScroll);
      }

      setIndex(indexFromCounter(), false);

      new MutationObserver(function () {
        var current = parseInt(counter.textContent, 10);

        if (!isNaN(current) && current > bars.length) {
          forceFirstState();
          return;
        }

        requestScrollSync();
      }).observe(counter, {
        childList: true,
        subtree: true,
        characterData: true
      });

      mediaList.addEventListener('mrartz:loop-reset', function () {
        forceFirstState();
        requestScrollSync();
      });

      mediaList.addEventListener('scroll', requestScrollSync, { passive: true });
      requestScrollSync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMrArtzGalleryProgress);
  } else {
    initMrArtzGalleryProgress();
  }

  document.addEventListener('shopify:section:load', initMrArtzGalleryProgress);
})();